import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { appleLogin, googleLogin, login } from "../../../store/Actions/authActions";
import AuthLayout, { Icon, SocialSignIn } from "../AuthLayout";
import { isValidEmail } from "../../../utils/password";
import "./login.css";

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      loggedIn: false,
      passwordShown: false,
      errors: {
        email: null,
        password: null,
      },
    };
  }

  responseGoogle = (response) => {
    this.props.dispatch(googleLogin(response));
  };

  handleChange = (event) => {
    const { errors } = this.state;
    errors[event.target.name] = null;
    this.setState({
      [event.target.name]: event.target.value,
      errors,
    });
  };

  togglePassword = () => {
    this.setState((prev) => ({ passwordShown: !prev.passwordShown }));
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });

    const postData = {
      email: this.state.email.trim(),
      password: this.state.password,
    };

    /* Le serveur n'est appelé qu'avec un formulaire valide. */
    if (!isValidEmail(postData.email)) {
      this.setState({
        errors: { email: "Enter a valid email address.", password: null },
        loading: false,
      });
      return;
    }

    await this.props.dispatch(login(postData));
    this.setState(
      this.props.auth ? { loading: false } : { loading: false, loggedIn: true }
    );
  };

  render() {
    const { t } = this.props;
    const { email, password, loading, loggedIn, passwordShown, errors } =
      this.state;
    const submitting = loading && !loggedIn;

    return (
      <AuthLayout
        t={t}
        eyebrow={t("Laundry & dry-cleaning")}
        title={t("Your laundry, picked up where you left it.")}
        lede={t("WOSH collects, cleans and returns your clothes, fresh and folded.")}
        chip={{ icon: "i-store", label: t("Connect with your local laundry store") }}
      >
        <h1 className="wosh-auth__title">{t("Welcome")}</h1>
        <p className="wosh-auth__lede">
          {t("Sign in to manage your orders, addresses and preferences.")}
        </p>

        {this.props.auth && (
          <div className="wosh-auth__alert">{t(this.props.auth)}</div>
        )}

        <form autoComplete="new-password" onSubmit={this.handleSubmit}>
          <label className="wosh-auth__label" htmlFor="signinEmail">
            {t("Email address")}
          </label>
          <div
            className={`wosh-auth__field${
              errors.email ? " wosh-auth__field--invalid" : ""
            }`}
          >
            <Icon name="i-mail" />
            <input
              autoComplete="new-password"
              type="email"
              id="signinEmail"
              name="email"
              placeholder="camille@exemple.be"
              value={email}
              onChange={this.handleChange}
            />
          </div>
          {errors.email && <p className="wosh-auth__error">{t(errors.email)}</p>}

          <div className="wosh-auth__label-row" style={{ marginTop: 20 }}>
            <label className="wosh-auth__label" htmlFor="signinPassword">
              {t("Password")}
            </label>
            <Link className="wosh-auth__link-small" to="/forgot-password">
              {t("Forgot password?")}
            </Link>
          </div>
          <div
            className={`wosh-auth__field${
              errors.password ? " wosh-auth__field--invalid" : ""
            }`}
          >
            <Icon name="i-lock" />
            <input
              autoComplete="new-password"
              type={passwordShown ? "text" : "password"}
              id="signinPassword"
              name="password"
              placeholder="••••••••"
              value={password}
              onChange={this.handleChange}
            />
            <button
              type="button"
              className={`wosh-auth__reveal${
                passwordShown ? " wosh-auth__reveal--on" : ""
              }`}
              onClick={this.togglePassword}
              aria-label={t("Show/Hide Password")}
            >
              <Icon name="i-eye" />
            </button>
          </div>
          {errors.password && (
            <p className="wosh-auth__error">{t(errors.password)}</p>
          )}

          <button
            type="submit"
            className="wosh-auth__cta"
            style={{ marginTop: 28 }}
            disabled={email === "" || password === "" || submitting}
          >
            {submitting && <span className="wosh-auth__spinner" />}
            {submitting ? t("processing") : t("Login Now")}
          </button>
        </form>

        <div className="wosh-auth__or">
          <span>{t("or")}</span>
        </div>

        <SocialSignIn
          t={t}
          onGoogle={this.responseGoogle}
          onApple={(authorization) =>
            this.props.dispatch(appleLogin(authorization))
          }
        />

        <p className="wosh-auth__switch">
          {t("Don't have an account yet?")}{" "}
          <Link to="/personal-details">{t("Create an account")}</Link>
        </p>
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state?.auth?.error,
});

export default compose(withTranslation(), connect(mapStateToProps))(SignIn);
